import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import VenueInventoryEditor from '../components/onboarding/VenueInventoryEditor';

/* Standing home for the equipment the venue owns. The same editor runs inside
   the onboarding wizard; this route is how a published venue gets back to it
   without walking backwards through the wizard. */
export default function MyVenueBacklinePage() {
  return (
    <div className="content-container" data-testid="my-venue-backline-page">
      <Link
        to="/venues/me"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-white transition"
      >
        <ArrowLeft size={14} /> Back to profile
      </Link>

      <h1 className="page-title gold-accent mt-6">Equipment</h1>
      <p className="text-sm text-muted-foreground mt-1">
        What you own, per room. Musicians check their rider against this, so an
        accurate list is worth more than a long one.
      </p>

      <div className="mt-6">
        <VenueInventoryEditor />
      </div>
    </div>
  );
}
